import React, {useState, useEffect, useRef} from "react";

import Markup from '../../markup';

type Props = {
    width?: number,
    offset?: number,
    borderRadius?: number,
    top?: boolean,
    bottom?: boolean,
    content:JSX.Element | string
    children:any
}

function TooltipHover({children, width, offset, borderRadius, top, bottom, content}:Props){
    const [active, setActive] = useState(false);
    const [arrowOffset, setArrowOffset] = useState(0);
    const contentEl = useRef(null);
    const wrapEl = useRef(null);

    useEffect(() => {
        if (contentEl.current && active) {
          setArrowOffset(Math.abs(contentEl?.current.offsetLeft) + wrapEl.current.offsetWidth / 2);
        }
      }, [contentEl, wrapEl, active]);

     const showTooltip = () => setActive(true);
     const hideTooltip = () => setActive(false);

    return(
        <Markup.Global.Tooltip.WrapContainer ref={wrapEl} onMouseLeave={hideTooltip} onMouseEnter={showTooltip}>
            {children}
            
            {active && 
                <Markup.Global.Tooltip.Content ref={contentEl} borderRadius={borderRadius} arrowOffset={arrowOffset} offset={offset} top={top} bottom={bottom} width={width} active={active}>
                    {content}
                </Markup.Global.Tooltip.Content>
            }
        </Markup.Global.Tooltip.WrapContainer>
    )
}

export default React.memo(TooltipHover);